import React, { createContext, Fragment, useContext, useRef, useState } from "react";
import { ConfirmationDialog } from "./ConfirmationDialog";

const ConfirmationServiceContext = createContext();

export const useConfirmation = () => useRef(useContext(ConfirmationServiceContext)).current;

export const ConfirmationDialogProvider = ({ children }) => {
    const [confirmationState, setConfirmationState] = useState(null);

    const openConfirmation = (options) => {
        setConfirmationState(options);
    };

    const handleClose = () => {
        if (confirmationState.onClose) {
            confirmationState.onClose();
        }
        setConfirmationState(null);
    };

    const handleSubmit = () => {
        if (confirmationState.onSubmit) {
            confirmationState.onSubmit();
        }
        setConfirmationState(null);
    };

    return (
        <Fragment>
            <ConfirmationServiceContext.Provider children={children} value={openConfirmation} />
            <ConfirmationDialog
                open={Boolean(confirmationState)}
                {...{
                    ...confirmationState,
                    onSubmit: handleSubmit,
                    onClose: confirmationState?.onClose ? handleClose : null,
                }}
            />
        </Fragment>
    );
};
